class ImageWithTextModal extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;

    this.cacheElements();
    this.bindEvents();

    this.initialized = true;
  }

  disconnectedCallback() {
    if (!this.initialized) return;

    this.openButtons.forEach((button) => button.removeEventListener('click', this.handleOpen));
    this.closeButtons.forEach((button) => button.removeEventListener('click', this.handleClose));
    document.removeEventListener('keydown', this.handleKeydown);
  }

  cacheElements() {
    this.overlay = this.querySelector('[data-image-with-text-modal-overlay]');
    this.content = this.querySelector('[data-image-with-text-modal-content]');
    this.openButtons = Array.from(this.querySelectorAll('[data-image-with-text-modal-trigger]'));
    this.closeButtons = Array.from(this.querySelectorAll('[data-image-with-text-modal-close]'));
  }

  bindEvents() {
    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);

    this.openButtons.forEach((button) => button.addEventListener('click', this.handleOpen));
    this.closeButtons.forEach((button) => button.addEventListener('click', this.handleClose));
    document.addEventListener('keydown', this.handleKeydown);
  }

  handleOpen(event) {
    const modalId = event.currentTarget.dataset.modalId;
    const source = this.querySelector(`[data-image-with-text-modal-source="${modalId}"]`);

    if (!source || !this.overlay || !this.content) return;

    this.setModalContent(source.innerHTML);
    this.toggleModal(true);
  }

  handleClose() {
    if (!this.overlay || !this.content) return;

    this.setModalContent('');
    this.toggleModal(false);
  }

  handleKeydown(event) {
    if (event.key === 'Escape' && this.overlay && this.overlay.hidden === false) {
      this.handleClose();
    }
  }

  setModalContent(content) {
    this.content.innerHTML = content;
  }

  toggleModal(isOpen) {
    this.overlay.hidden = !isOpen;
    document.body.classList.toggle('image-with-text-modal-open', isOpen);
  }
}

if (!customElements.get('image-with-text-modal')) {
  customElements.define('image-with-text-modal', ImageWithTextModal);
}
